import { Fragment, useEffect, useMemo, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { RiHome6Line, RiUserSettingsLine, RiUserStarLine } from "react-icons/ri";
import { TiArrowSortedDown, TiDocumentText } from "react-icons/ti";
import { TbBasketDollar, TbBrandGoogleAnalytics, TbCategoryPlus, TbClockStar, TbDeviceAnalytics, TbDiscount2, TbReportAnalytics, TbReportSearch, TbRotateRectangle, TbScreenShare, TbSettingsAutomation, TbTimelineEventPlus, TbTransfer, TbUserHeart } from "react-icons/tb";
import { BiCartAdd, BiMessageAltDetail } from "react-icons/bi";
import { GrPlan, GrResources, GrUserSettings } from "react-icons/gr";
import { HiOutlineCreditCard, HiOutlineEnvelope, HiOutlineUsers } from "react-icons/hi2";
import { GoBroadcast } from "react-icons/go";
import { CgFormatText } from "react-icons/cg";
import { FiClock, FiLink, FiPhone, FiSliders, FiVideo } from 'react-icons/fi';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { HiOutlineArrowPath } from "react-icons/hi2";
import { HiOutlineStar } from "react-icons/hi2";
import { BsPhone } from "react-icons/bs";
import { BiPhoneOutgoing } from "react-icons/bi";
import {
  MdContentPaste,
  MdOutlineGroups,
  MdOutlineAudioFile,
  MdCardMembership,
  MdOutlineManageAccounts,
  MdManageHistory,
  MdOutlineInventory,
  MdOutlineInventory2,
  MdLocalOffer,
} from "react-icons/md";
import { LiaUserTagSolid } from "react-icons/lia";
import ApiClient from "../../../methods/api/apiClient";
import { FiGift, FiSettings, FiUsers } from "react-icons/fi";
import { FaDollarSign, FaQuestion } from "react-icons/fa";
import { BsCartCheck, BsCartPlus, BsListStars } from "react-icons/bs";
import contentLibrary from "../../../Pages/contentLibrary";
import { IoMdShare } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
import { SlShareAlt } from "react-icons/sl";
import { LuArchiveRestore, LuBox, LuCheckCheck, LuListStart } from "react-icons/lu";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { UserCircleIcon } from "@heroicons/react/20/solid";
import { MdOutlineAnalytics } from "react-icons/md";

const Html = ({ ListItemLink, tabclass, isAllow, route, isOpen, user, setIsopen = (_) => { } }) => {
  const [membershipCount, setMembershipCount] = useState(JSON.parse(localStorage.getItem('membershipCount') || '[]'));
  const location = useLocation();

  const getMembershipCount = () => {
    ApiClient.get('user/memberShipCount').then(res => {
      if (res.success) {
        let value = res.data
        let arr = Object.keys(value)
        arr = arr.filter(itm => itm != 'Groove Group')
        arr = arr.map(itm => ({ name: itm, count: value?.[itm], id: itm.replaceAll(' ', '_') }))
        localStorage.setItem('membershipCount', JSON.stringify(arr))
        setMembershipCount(arr)
      }
    })
  }

  useEffect(() => {
    getMembershipCount()
  }, [])


  const isMobile = useMemo(() => {
    let clientWidth = document.body.clientWidth;
    let value = false;
    if (clientWidth < 767) value = true;
    return value;
  }, []);

  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname === "/customers" || location.pathname.startsWith("/customers/")) {
      navigate("/checkin", { replace: true });
    }
  }, [location.pathname, navigate]);

  const menus = [
    {
      type: 'title',
      name: "Main Menu",
    },
    // {
    //   name: "Order Fulfillment",
    //   icon: <LuBox className="text-white shrink-0 text-lg" />,
    //   url: "/order-fulfillment",
    //   key: "readOrderFulfillment",
    // },
    {
      name: "Analytics",
      icon: <TbDeviceAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
        }`} />,
      tab: "",
      menu: [
        {
          name: "Dashboard Overview",
          icon: <RiHome6Line className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
            }`} />,
          url: "/dashboard",
          key: "readDashboard",
        },
        //  {
        //   name: "Experience Dashboard",
        //   icon: <RiHome6Line className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
        //     }`} />,
        //   url: "/experience",
        //   key: "readExperience ",
        // },
        {
          name: "Loyal Member",
          icon: <TbUserHeart className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "",
          menu: [
            {
              name: "Membership Metrics",
              icon: <GrPlan className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
                }`} />,
              url: "/membership/insights",
              key: "readDashboard",
            },
            {
              // Rewards & Discounts
              name: "Rewards",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/reward/analytics",
              key: "readDashboard",
            },
            {
              // Rewards & Discounts
              name: "Discounts",
              icon: <TbDiscount2 className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/discount/analytics",
              key: "readDashboard",
            },
            // {
            //   name: "Bundle Engagement",
            //   icon: <TbReportAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/box/analytics",
            //   key: "readDashboard",
            // },

            {
              name: "Bundle Engagement",
              icon: <TbReportAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/box/analytics2",
              key: "readDashboard",
            },
            {
              name: "History",
              icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              menu: [
                {
                  name: "Membership Lifecycle History",
                  icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/membership/history",
                  key: "readDashboard",
                },
                {
                  name: "Reward Redemption History",
                  icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/wallet-points",
                  key: "readDashboard",
                },
                {
                  name: "Bundle Fulfillment History",
                  icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: '/box/report-list',
                  key: 'readDashboard'
                  // menu: [
                  //   {
                  //     name: "Bundle Status Reports",
                  //     icon: <HiOutlineDocumentReport className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  //     url: "/box/report",
                  //     key: "readBox",
                  //   },
                  //   {
                  //     name: "Bundle Orders Report",
                  //     icon: <HiOutlineDocumentReport className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  //     url: "/box/report-list",
                  //     key: "readBox",
                  //   },
                  // ],
                },
              ],
            },
            // {
            //   name: "Checkin Status Report",
            //   icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/loyal-member",
            //   key: "readCheckin",
            // },
          ]
        },
        {
          name: "Groove Guide",
          icon: <RiUserStarLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "",
          menu: [
            {
              name: "Engagement & Content",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/groove-guide",
              key: "readDashboard",
            },
            {
              name: "Shared By Experience and Benefits",
              icon: <TbScreenShare className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
                }`} />,
              tab: "",
              menu: [
                {
                  name: "Shared By Experience and Benefits",
                  icon: <TbScreenShare className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/dashboard/share-experience-overview",
                  key: "readDashboard",
                },
                {
                  name: "Shared Experience and Benefits By Products",
                  icon: <TbScreenShare className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/dashboard/share-experience-by-product",
                  key: "readDashboard",
                },
              ],
            },

            {
              name: "History",
              icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              menu: [
                {
                  name: "Onboarding Funnel Analytics",
                  icon: <RiUserSettingsLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/groove-guide/reports",
                  key: "readDashboard",
                },
                {
                  name: "Experience Feedback History",
                  icon: <TbScreenShare className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/dashboard/share-experience-history",
                  key: "readDashboard",
                },
              ],
            },

          ]
        },
        {
          name: "Sales Performance",
          icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
            }`} />,
          tab: "",
          menu: [
            {
              name: "Item-Level Sales",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
                }`} />,
              url: "/sales/insights",
              key: "readDashboard",
            },

            {
              name: "Membership & Bundle Sales",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
                }`} />,
              url: "/membership/boxsale",
              key: "readDashboard",
            },
            {
              name: "Regional Sales Trends",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/sales/regional",
              key: "readDashboard",
            },
            {
              name: "History",
              icon: <HiOutlineEnvelope className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              menu: [
                {
                  name: "Order History",
                  icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/sales/history",
                  key: "readDashboard",
                },
              ]
            },
          ],
        },
        {
          name: "Marketing",
          icon: <HiOutlineEnvelope className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          menu: [
            {
              name: "Dashboard",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/seo/dashboard",
              key: "readDashboard",
            },
            {
              name: "Seo Analytics",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,

              key: "readDashboard",
              menu: [
                {
                  name: "Dashboard",
                  icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/marketing/seo",
                  key: "readDashboard",
                },
                {
                  name: "Reporting",
                  icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/marketing/seo/reporting",
                  key: "readDashboard",
                },

              ]
            },
            {
              name: "SEO Reports",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,

              key: "readDashboard",
              menu: [
                {
                  name: "AI Ranking",
                  icon: <LuListStart className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/rankchecker",
                  key: 'readAutomation'
                },
                {
                  name: "Keyword Research",
                  icon: <TbSettingsAutomation className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/keywordsresearch",
                  key: 'readAutomation'
                },
                {
                  name: "Automation Content",
                  icon: <TiDocumentText className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/automation",
                  key: 'readAutomation'
                },
                {
                  name: "SEO Audit",
                  icon: <LuListStart className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                  url: "/marketing/seo/audit",
                },
              ]
            },
            {
              name: "Referral & Demographics",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/marketing/referral",
              key: "readDashboard",
            },
            {
              name: "Campaign Performance",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/marketing/campaign-performance",
              key: "readDashboard",
            },
            {
              name: "Reports",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/marketing",
              key: "readDashboard",
            },
          ]
        },
        {
          name: "Engagement & Surveys",
          icon: <HiOutlineEnvelope className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          menu: [
            {
              name: "Behavioral Metrics",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/survey/behavioral",
              key: "readDashboard",
            },
            {
              name: "Survey Data",
              icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/dashboard/survey-data",
              key: "readDashboard",
            },
          ]
        },
        // {
        //   name: "Box Analytics",
        //   icon: <TbReportAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
        //   url: "/box/analytics",
        //   key: "readDashboard",
        // },
        // {
        //   name: "Bundle Status Reports",
        //   icon: <HiOutlineDocumentReport className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
        //   url: "/box/report",
        //   key: "readDashboard",
        // },
        // {
        //   name: "Checkin Report",
        //   icon: <HiOutlineDocumentReport className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
        //   url: "/checkin-report",
        //   key: "readDashboard",
        // },

        {
          name: "Checkin Report",
          icon: <HiOutlineDocumentReport className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/checkin-reports",
          key: "readDashboard",
        },

        {
          name: "Payment Status & Transaction Origin",
          icon: <HiOutlineCreditCard className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/paymentStatusNew",
          key: "readDashboard",
        },
        // {
        //   name: "Payment Status new",
        //   icon: <HiOutlineCreditCard className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
        //   url: "/paymentStatusNew",
        //   key: "readDashboard",
        // },
        {
          name: "Backend Experiences",
          icon: <HiOutlineCreditCard className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/backendExperiences",
          key: "readDashboard",
        },

      ],
    },
    {
      name: "Staff",
      icon: <FiUsers className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/user",
      key: "readstaff",
    },
    {
      name: "Manage Membership",
      icon: <GrPlan className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
        }`} />,
      url: "/plans",
      key: "readPlan",
    },
    // {
    //   name: "Sales",
    //   icon: <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //   url: "/orders",
    //   key: "readOrder",
    // },
    // {
    //   name: "Sales",
    //   icon:  <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //   menu: [
    //     {
    //       name: "Sales Insights",
    //       icon: <TbBrandGoogleAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //       url: "/sales/insights",
    //       key: "readOrder",
    //     },
    //     {
    //       name: "Items Sales",
    //       icon: <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //       url: "/orders",
    //       key: "readOrder",
    //     },
    //   ],
    // },

    {
      name: "Reward Management",
      icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      menu: [
        {
          name: "Reward Requests",
          icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/reward-request",
          key: "readRewardRequest",
        },
        {
          name: "Reward Types",
          icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/reward-type",
          key: "readRewardTypes",
        },

      ],
    },

    {
      name: "Discount Management",
      icon: <MdLocalOffer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      menu: [
        {
          name: "Discount Report",
          icon: <MdLocalOffer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/discount-report",
          key: "readDiscountReport",
        },
      ],
    },
    {
      name: "Loyal Member",
      icon: <TbUserHeart className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      key: "",
      menu: [
        {
          name: "Add Member",
          icon: <IoPersonAddOutline className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/member/add",
          key: "addMember",
        },
        {
          name: "Referrals",
          icon: <SlShareAlt className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/referrals",
          key: "readReferrals",
        },

        {
          name: "Checkin",
          icon: <LuCheckCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/checkin",
          key: "readCheckin",
        },
        {
          name: "ID Verification Settings",
          icon: <FiSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/checkin-settings",
          key: "editCheckinSettings",
        },
        {
          name: "Bundle Management Report",
          icon: <GrUserSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/box",
          key: "readBox",
        },
        {
          name: "Bundle Management Report 2.0",
          icon: <GrUserSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/box2.0",
          key: "readBox",
        },
      ]
    },
    // {
    //   name: "Groove Guide",
    //   icon: <RiUserStarLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //   key: "",
    //   menu: [
    //     {
    //       name: "Onboarding Questions",
    //       icon: <RiUserSettingsLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //       url: "/question",
    //       key: "readonboardingQuestions",
    //     },
    //     // {
    //     //   name: "Contacts",
    //     //   icon: <HiOutlineUsers className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //   key: "readgrooveGroup",
    //     //   menu: [
    //     //     {
    //     //       name: "Craft Group",
    //     //       icon: <MdOutlineGroups className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/customers/craft",
    //     //       key: "readgrooveGroup",
    //     //       menu: [
    //     //         ...membershipCount.map(itm => {
    //     //           return {
    //     //             name: `${itm.name} (${itm.count})`,
    //     //             // icon: <FiGift className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0" }`} />,
    //     //             url: `/customers/craft/${itm.id}`,
    //     //             key: "readgrooveGroup",
    //     //           }
    //     //         }),
    //     //       ]
    //     //     },
    //     //     {
    //     //       name: "Groove Group",
    //     //       icon: <MdOutlineGroups className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/customers/groove",
    //     //       key: "readgrooveGroup",
    //     //     },
    //     //   ]
    //     // },
    //     // {
    //     //   name: "Menu Management",
    //     //   icon: <MdOutlineManageAccounts className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //   key: "",
    //     //   menu: [
    //     //     {
    //     //       name: "Products",
    //     //       icon: <BiCartAdd className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/product",
    //     //       key: "readProducts",
    //     //     },
    //     //     {
    //     //       name: "Product Category",
    //     //       icon: <BiCartAdd className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/product-category",
    //     //       key: "readProducts",
    //     //     },
    //     //     {
    //     //       name: "Infused by",
    //     //       icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/strain",
    //     //       key: "readInfusedBy",
    //     //     },
    //     //     {
    //     //       name: "Deals",
    //     //       icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/deal",
    //     //       key: "readDeal",
    //     //     },
    //     //     {
    //     //       name: "Merch",
    //     //       icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/merch-category",
    //     //       key: "readMerch",
    //     //     },
    //     //     {
    //     //       name: "This Month's Bundle",
    //     //       icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/month-box",
    //     //       key: "readMonthBox",
    //     //     },
    //     //     {
    //     //       name: "Banners",
    //     //       icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //     //       url: "/banner",
    //     //       key: "readBanners",
    //     //     },
    //     //   ]
    //     // },
    //   ]
    // },
    /*EVA menu options start*/
    {
      name: "EVA",
      icon: <FiPhone className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      key: "",
      menu: [
        {
          name: "Agents",
          icon: <HiOutlineUserGroup className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/eva/agent",
          key: "readAgents",
        },
        {
          name: "Call Log Management",
          icon: <BsPhone className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          menu: [
            {
              name: "Call Logs",
              icon: <BiPhoneOutgoing className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/eva/call-logs",
              key: "readCallLogs",
            },
            //  {
            //   name: "Transfer Call Logs",
            //   icon: <BiPhoneOutgoing className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/eva/transfer-call-logs",
            //   key: "readTransferCallLogs",
            // },
            {
              name: "Call Analytics",
              icon: <MdOutlineAnalytics className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/eva/call-analytics",
              key: "readCallAnalytics",
            },
          ]
        },
        {
          name: "Messaging Inbox",
          icon: <HiOutlineArrowPath className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/eva/messaging-inbox",
          key: "readMessagingInbox",
        },
        {
          name: "Fallback Handling",
          icon: <HiOutlineArrowPath className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/eva/fallback-handling",
          key: "readFallbackHandling",
        },
        {
          name: "Call Rating",
          icon: <HiOutlineStar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/eva/call-ratings",
          key: "readCallRating",
        },

        {
          name: "Conversation Quality (QA)",
          icon: <TiDocumentText className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/eva/quality-reports",
          key: "readCallLogs",
        }



      ]
    },
    /*EVA menu options ends*/
    {
      name: "Manage Survey",
      icon: <MdManageHistory className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/survey",
      key: "readSurvey",
    },
    {
      name: "Experience,Intension and Benefits Management",
      icon: <TbClockStar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/tag",
      key: "readShareExperience",
    },

    {
      // name: "Resource Center Management",
      name: "Groove Guide Content Management",


      icon: <GrResources className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      key: "",
      menu: [
        {
          name: "Content Library Categories",
          icon: <TbCategoryPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/category",
          key: "readCategories",
        },
        {
          name: "Passes",
          icon: <TbCategoryPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/passes",
          key: "readPasses",
        },
        {
          name: "Content Library",
          icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/groove/videos",
          key: 'readGrooveVideo',
        },
        {
          name: "Onboarding Questions",
          icon: <RiUserSettingsLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/question",
          key: "readonboardingQuestions",
        },
        {
          name: "Content Management",
          icon: <MdContentPaste className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/content-library",
          key: "readVideos",
          tab: "content-library",
          menu: [
            {
              name: "New This Week",
              icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/this-week-playlist",
              key: 'readContent',
            },
            // {
            //   name: "Groove Guide TV",
            //   icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/groove/videos",
            //   key: 'readGrooveVideo',
            // },
            {
              name: "Guides & Downloads",
              icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/guide/downloads",
              key: 'readGuidesDownloads',
            },
            ...contentLibrary.list.map(item => {
              return {
                name: item.name,
                icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
                url: `${item.url}`,
                key: item.library == 'video' ? 'readContent' : 'readContent',
              }
            }),
            {
              name: "FAQ",
              icon: <FaQuestion className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/faq",
              key: "readContent",
            },
            {
              name: "Static Pages",
              icon: <MdContentPaste className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/content",
              key: "readContent",
            },
            {
              name: "Guide",
              icon: <GrResources className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/resources",
              key: "readContent",
            },
          ]
        },

        {
          name: "Live Page Settings",
          icon: <FiSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/go/live",
          key: "readLiveSettings",
        },
        {
          name: "Kiosk Management",
          icon: <FiSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readKioskManagement",
          menu: [
            {
              name: "Idle Time",
              icon: <FiClock className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/kiosk-management",
              key: "readKioskManagement",
            },
            {
              name: "Welcome Series",
              icon: <FiVideo className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/welcomeSeries",
              key: "readKioskManagement",
            },
            // {
            //   name: "Redirect Links",
            //   icon: <FiLink className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/redirect-links",
            //   key: "readKioskManagement",
            // },
          ]
        },
        {
          name: "Menu Management",
          icon: <MdOutlineManageAccounts className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "",
          menu: [


            {
              name: "Deals",
              icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/deal",
              key: "readDeal",
            },
            {
              name: "Merch",
              icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/merch-category",
              key: "readMerch",
            },
            {
              name: "This Month's Bundle",
              icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/month-box",
              key: "readMonthBox",
            },
            {
              name: "Banners",
              icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/banner",
              key: "readBanners",
            },
          ]
        },
      ]
    },
    {
      name: "Marketing",
      icon: <HiOutlineEnvelope className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      menu: [
        {
          name: "Broadcast",
          icon: <GoBroadcast className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/notifications",
          key: "readBroadcast",
        },

      ]
    },
    {
      name: "Inventory Management",
      icon: <LuArchiveRestore className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      menu: [
        {
          name: "Inventory Location",
          icon: <LuArchiveRestore className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,

          key: "readInventory",
          menu: [
            {
              name: "Basement Hub",
              icon: <LuArchiveRestore className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory",
              key: 'readInventory',
            },
            {
              name: "Retail Inventory",
              icon: <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventoryRetail",
              key: "readRetailInventory",
            },
            {
              name: "Bundle Inventory",
              icon: <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/boxInventory",
              key: "readBoxInventory",
            },
            {
              name: "Bundle Hub",
              icon: <BsCartCheck className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/boxHub",
              key: "readBoxHub",
            },

          ]
        },

        {
          name: "Purchase Order",
          icon: <TbBasketDollar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readPurchaseManagement",
          menu: [
            {
              name: "Purchase History",
              icon: <TbBasketDollar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/po/history",
              key: 'readPurchaseHistory',
            },
            {
              name: "Purchase Management",
              icon: <TbBasketDollar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/po",
              key: 'readPurchaseManagement',
            },
            {
              name: "Initiate Purchase Order",
              icon: <TbBasketDollar className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/po/add",
              key: 'addPurchaseManagement',
            },
          ]
        },
        {
          name: "Transfer",
          icon: <TbTransfer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readTransferManagement",
          menu: [
            {
              name: "Transfer History",
              icon: <TbTransfer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/internal-transfer/history",
              key: 'readTransferHistory',
            },
            {
              name: "Transfer Management",
              icon: <TbTransfer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/internal-transfer",
              key: 'readTransferManagement',
            },
            {
              name: "Initiate Transfer",
              icon: <TbTransfer className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/internal-transfer/add",
              key: 'addTransferManagement',
            },
          ]
        },
        {
          name: "Conversion ",
          icon: <MdOutlineInventory className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readConversionManagement",
          menu: [
            {
              name: "Conversion History",
              icon: <MdOutlineInventory className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/conversion/history",
              key: 'readConversionHistory',
            },
            {
              name: "Conversion Management",
              icon: <MdOutlineInventory className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/conversion",
              key: 'readConversionManagement',
            },
            {
              name: "Initiate Conversion",
              icon: <MdOutlineInventory className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/conversion/add",
              key: 'addConversionManagement',
            },
          ]
        },
        {
          name: "Reconcile",
          icon: <TbRotateRectangle className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readReconcileManagement",
          menu: [
            {
              name: "Reconcile History",
              icon: <TbRotateRectangle className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventoryReconcile/history",
              key: 'readReconcileHistory',
            },
            {
              name: "Reconcile Management",
              icon: <TbRotateRectangle className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventoryReconcile",
              key: 'readReconcileManagement',
            },
            {
              name: "Manage Reasons",
              icon: <TbRotateRectangle className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/reasons",
              key: 'readReconcileReason',
            },
            {
              name: "Add Reconcile",
              icon: <TbRotateRectangle className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventoryReconcile/add",
              key: 'addReconcileManagement',
            },
          ],
        },
        {
          name: "Products",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readInventoryProducts",
          menu: [
            {
              name: "Manage Products",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/product",
              key: 'readInventoryProducts',
            },

            {
              name: "Add Product",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/product/add",
              key: 'addInventoryProducts',
            },
            {
              name: "Manage Retail Price",
              icon: <FaDollarSign className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/RetailPrice",
              key: 'readInventoryProduct',
            },
            {
              name: "Manage UOM",
              icon: <TbCategoryPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/uom",
              key: "readInventoryProducts",
            },
            {
              name: "Manage Brands",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/brands",
              key: 'readInventoryProducts',
            },
            {
              name: "Infused by",
              icon: <LiaUserTagSolid className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/strain",
              key: "readInventoryProducts",
            },
            // {
            //   name: "Manage Infused By",
            //   icon: <TbCategoryPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/infusedby",
            //   key: 'readInventoryInfusedBy',
            // },
            // {
            //   name: "Manage Categories",
            //   icon: <TbCategoryPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/inventory/category",
            //   key: 'readInventoryCategories',
            // },
            {
              name: "Manage Sub-Category",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/subcategory",
              key: 'readInventoryProducts',
            },

            {
              name: "Manage Group",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/group",
              key: 'readInventoryProducts',
            },

          ]
        },
        {
          name: "Inventory Thresholds",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readInventoryThreshold",
          menu: [
            {
              name: "Manage Thresholds",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/thresholds",
              key: 'readInventoryThreshold',
            },
            {
              name: "Threshold Dashboard",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/thresholds/dashboard",
              key: 'readThresholdDashboard',
            },
            {
              name: "Manage Families",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/thresholds/families",
              key: 'readFamilyManagement',
            }
          ],
        },
        {
          name: "Barcode",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readBarCodeManagement",
          menu: [
            {
              name: "Print Barcode",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/barcode/add",
              key: 'addBarCodeManagement',
            },
            // {
            //   name: "QR Code for Shared Experience",
            //   icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
            //   url: "/inventory/barcode/shared",
            //   key: 'readQRCodeShared',
            // },
          ]
        },
        {
          name: "QR Code",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readBarCodeManagement",
          menu: [
            {
              name: "Print QR Code",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/qrcode/add",
              key: "addBarCodeManagement",
            },
          ]
        },
        {
          name: " Vendors",
          icon: <RiUserSettingsLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,

          key: "readVendorProducts",
          menu: [
            {
              name: "Add Vendor",
              icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/vendor/add",
              key: 'addVendorProducts',
            },
            {
              name: "Vendor Management",
              icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/vendor",
              key: 'readVendorProducts',
            },

            {
              name: "Vendor Requests",
              icon: <MdOutlineAudioFile className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/inventory/vendor/request",
              key: 'readVendorRequests',
            },
          ]
        },
        {
          name: "Global Activity Timeline",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/inventory/activity/timeline",
          key: 'readActivityTimeline'
        }
        //     {
        //       name: (
        //         <div className="relative flex gap-1 flex-wrap items-center">
        //           <span>Inventory Messages</span>
        //           {user?.unreadInventoryMessages > 0 && (
        //             <div className="">
        //               <span className="ml-2 text-xs bg-red-500 w-10 md:w-auto text-white rounded-full p-1 md:px-2 py-0.5">
        //                 {user.unreadInventoryMessages}
        //               </span>
        //             </div>
        //           )}

        //         </div>
        //       ),
        //       icon: (
        //         <BiMessageAltDetail
        //           className={`${isOpen
        //             ? "mb-1 block text-[#fff] shrink-0 text-lg"
        //             : "text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"
        //             }`}
        //         />
        //       ),
        //       url: "/inventoryMessage",
        //       key: "readInventory",
        //     },


        //     // {
        //     //   name: "Logs",
        //     //   icon: <AiOutlineFileText className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
        //     //   url: "/inventory/logs",
        //     //   key: "readInventory",
        //     // },

        //   ]
        // },

      ]
    },
    {
      name: "Groove Grill",
      icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      key: "readInventory",
      menu: [
        {
          name: "Weekly Meals",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          key: "readInventory",
          menu: [
            {
              name: "Weekly Meal Orders",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/weeklyMealOrders",
              key: 'readInventory',
            },
            {
              name: "Groove Meal Plans",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveMealPlans",
              key: 'readInventory',
            },
            {
              name: "Groove Meal Type",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveMealType",
              key: 'readInventory',
            },

            {
              name: "Most popular grooves",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/MostPopularGrooves",
              key: 'readInventory',
            },
            {
              name: "Groove Build Your Own ",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveBuildYourOwn",
              key: 'readInventory',
            },

            {
              name: "Groove Extra Meals ",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveExtraMeals",
              key: 'readInventory',
            },
            {
              name: "Groove Drinks ",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveDrinks",
              key: 'readInventory',
            },

            {
              name: "Groove Location/Tax ",
              icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
              url: "/GrooveLocation/edit/69ce22b9fa82f6907e0a6010",
              key: 'readInventory',
            },

          ]
        },

        {
          name: "Events",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/GrooveEvents",
          key: 'readGrooveEvents',
        },
        {
          name: "Catering",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/GrooveCatering",
          key: 'readGrooveCatering',
        },
        {
          name: "Event request",
          icon: <BsCartPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/GrooveEventRequest",
          key: 'readGrooveEventRequest',
        },


      ]
    },
    // {
    //   name: "Events",
    //   icon: <TbTimelineEventPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //   url: "/events",
    //   key:'readEvents'
    // },
    {
      name: "Monthly Bundles",
      icon: <TbTimelineEventPlus className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/monthly-box",
      key: 'readMonthBox'
    },

    {
      name: "Partner Requests",
      icon: <UserCircleIcon className={`h-5 w-5 ${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/partner/request",
    },
    // {
    //   name: "Live Page Settings",
    //   icon: <FiSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
    //   url: "/go/live",
    //   key: "readLiveSettings",
    // },

    {
      name: "Settings",
      icon: <FiSettings className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/profile/settings",
      key: "readAll",
    },

    {
      name: "Content Settings",
      icon: <FiSliders className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/contentSettings",
      key: "readAll",
    },

    {
      name: "CC Events Settings",
      icon: <FiSliders className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
      url: "/events",
      key: "readAll",
    },
    {
      name: "Archive",
      icon: <RiUserSettingsLine className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,

      key: "readProducts",
      menu: [
        {
          name: "Products",
          icon: <BiCartAdd className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/product",
          key: "readProducts",
        },
        {
          name: "Product Category",
          icon: <BiCartAdd className={`${isOpen ? " mb-1 block  text-[#fff] shrink-0 text-lg" : " text-[#fff] shrink-0 text-lg mb-2 block md:mb-0"}`} />,
          url: "/product-category",
          key: "readProducts",
        },]
    }
  ];

  function extractUrlsFromArray(dataArray) {
    let urls = [];

    function recurse(item) {
      if (item.url) {
        urls.push(item.url);
      }
      if (item.menu && Array.isArray(item.menu)) {
        item.menu.forEach(recurse);
      }
    }

    dataArray.forEach(item => recurse(item));
    return urls;
  }
  const tabactive = (urls) => {
    let url = window.location.pathname;
    let value = false;
    urls?.forEach((itm) => {
      if (url === itm || url.startsWith(`${itm}/`)) {
        value = true;
      }
    });
    return value;
  };

  const allExplicitUrls = extractUrlsFromArray(menus);

  // A leaf nav item should only be highlighted when:
  // 1. exact match, OR
  // 2. current path starts with itemUrl + '/' AND no longer/more-specific
  //    explicit sidebar URL also matches the current path.
  // This prevents e.g. /inventory lighting up on /inventory/product/add,
  // and /thresholds lighting up on /thresholds/dashboard.
  const isActive = (itemUrl) => {
    const path = location.pathname;
    if (path === itemUrl) return true;
    if (path.startsWith(itemUrl + '/')) {
      const hasMoreSpecificMatch = allExplicitUrls.some(
        (u) => u.length > itemUrl.length && (path === u || path.startsWith(u + '/'))
      );
      return !hasMoreSpecificMatch;
    }
    return false;
  };

  const Menu = ({ itm }) => {
    return <>
      <>
        {itm.type != 'title' ? (
          <>
            <li>
              {itm.menu ? (
                <>
                  {isAllow(
                    itm.menu.map((itm) => itm.key)
                  ) ? (
                    <>
                      <Disclosure
                        as="div"
                        defaultOpen={tabactive(extractUrlsFromArray(itm.menu))}
                      >
                        {({ open }) => (
                          <>

                            <Disclosure.Button className={`${isOpen ? " relative p-1.5 rounded-md flex items-center justify-between text-[#fff]  hover:!text-[#fff] gap-[10x] hover:bg-[#540C0F] transition-all duration-300" : " w-full p-2.5 rounded-md flex items-center justify-between text-[#fff]  hover:!text-[#fff] gap-[12px] hover:bg-[#540C0F] transition-all duration-300"}`} >
                              <span className="text-sm font-normal text-inherit flex items-center gap-[12px] crm">
                                {itm.icon}
                                <span className={`${isOpen ? " text-inherit leading-none sidebar_text" : " text-inherit leading-none sidebar_text !leading-[20px]  text-left"
                                  }`}>
                                  {itm.name}
                                </span>
                              </span>
                              <TiArrowSortedDown
                                className={`${open ? "" : "-rotate-90 shrink-0  transform"
                                  } h-4 w-4  transition-all duration-500   text-[#fff]`}
                              />
                            </Disclosure.Button>

                            <Transition
                              enter="transition duration-300 ease-in-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-300 opacity-300"
                              leave="transition duration-300 ease-in-out"
                              leaveFrom="transform scale-300 opacity-300"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel className="pl-[30px] mt-[4px] ">
                                <ul className="space-y-2">
                                  {itm.menu?.map((sitm, si) => {
                                    return <Fragment key={si}>
                                      <Menu itm={sitm} />
                                    </Fragment>
                                  })}
                                </ul>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {isAllow([itm.key]) ? (
                    <>

                      <span
                        onClick={() => {
                          navigate(itm.url)
                          if (isMobile) {
                            console.log("is mobile")
                            setIsopen(false)
                          }
                        }}
                        to={itm.url}
                        className={"p-2.5 rounded-md cursor-pointer flex items-center gap-[12px] text-sm font-normal text-[#fff] hover:!text-[#fff] hover:bg-[#540C0F] !no-underline transition-all " +
                          (isActive(itm.url) && " !text-[#fff] !bg-[#540C0F] !font-medium")}
                      >
                        {itm.icon}
                        <span className="text-inherit  sidebar_text  leading-5">
                          {itm.name}
                        </span>
                      </span>

                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </li>
          </>
        ) : (
          <>
            <li>
              <h6
                className={`${isOpen
                  ? "py-[12px] text-center"
                  : "p-[12px] text-center text-md"
                  } text-xs font-medium text-[#7E8B99] mt-[12px]`}
              >
                <span className=" sidebar_text text-center">
                  {" "}
                  {itm.name}{" "}
                </span>
              </h6>
            </li>
          </>
        )}
      </>
    </>
  }

  return (
    <>
      <div
        className={`px-[8px] flex items-center ${!isOpen ? 'flex-col justify-center' : ''} ${isOpen ? styles.sm_sidebar : ''}`}

        component="siderbar"
      >
        <ul className="space-y-2 px-2">
          {menus.map((itm, i) => {
            return <Fragment key={i}>
              <Menu itm={itm} />
            </Fragment>
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
